export default "__VITE_ASSET__2xo$SDJZ__"